import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fadd12c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3fadd12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fadd12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fadd12c')) {
      api.createRecord('3fadd12c', component.options)
    } else {
      api.reload('3fadd12c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fadd12c&scoped=true&", function () {
      api.rerender('3fadd12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemMgr/menuMgr/index.vue"
export default component.exports